import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const DownstreamMetricsFilteredByFieldQueryGql: DocumentNode = gql`
query DownstreamMetricsFilteredByFieldQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...MetricsDisplayGridRowDataFragment
        }
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
